<script>
import axios from 'axios';
import {InboundOrderPath} from '@/path.js';
import Swal from 'sweetalert2';

    export default {
        props : ['r','form','type'],
        data(){
            return {
                baseUrl : process.env.VUE_APP_API_BACKEND_URL,
                data : [],
                currentPage : 1,
                selectedBatches : [],
                filter : [],
                required_qty : 0,
                fulfilled_qty : 0,
                fields : ['batch_code','warehouse_details','qty','best_before','action']
            }
        },
        watch :{
            currentPage(){
                this.getBatches();
            }
        },
        methods : {
            save(){
                this.$emit('selectedBatches',this.selectedBatches);
                this.$bvModal.hide('add-batches');
            },
            addBatch(v){
                console.log(v);
                this.fulfilled_qty += v.qty;
                if(this.fulfilled_qty >= this.required_qty){
                    this.fulfilled_qty = this.required_qty;
                    console.log(this.selectedBatches.filter(f => f.b_code != v.b_code).reduce((a,c) => {return a + c.qty},0));
                    if(this.selectedBatches.length > 0 && this.selectedBatches.filter(f => f.b_code != v.b_code).reduce((a,c) => {return a + c.qty},0) >= this.required_qty){
                        Swal.fire('Batches Fulfilled the required qty');
                        return;
                    }
                }
                this.selectedBatches.push(v);
            },
            removeBatch(v){
                this.selectedBatches = this.selectedBatches.filter(f => f.b_code != v.b_code);
                this.fulfilled_qty -= v.qty;
                if(this.fulfilled_qty < 0){
                    this.fulfilled_qty = 0;
                }                
            },
            async getBatches(){
                try {
                    if(this.type == 'gravies'){
                        console.log(this.form);
                        this.required_qty = this.form.gravies.filter(f => f.id == this.r.id)[0].qty_to_ship
                        this.selectedBatches = this.form.gravies.filter(f => f.id == this.r.id)[0].batches?.map(b => {let d = b; d.b_code = b.batch.batch_code; d.qty = b.qty_exists; return d});
                        if(!this.selectedBatches){
                            this.selectedBatches = [];
                        }
                        let v = this.selectedBatches.reduce((a,c) => {return a + c.qty},0);
                        this.fulfilled_qty = v > this.required_qty ? this.required_qty : v;
                    }else{
                        this.required_qty = this.form.packagings.filter(f => f.id == this.r.id)[0].qty_to_ship
                        this.selectedBatches = this.form.packagings.filter(f => f.id == this.r.id)[0].batches?.map(b => {let d = b; d.b_code = b.batch.batch_code; d.qty = b.qty_exists; return d});
                        if(!this.selectedBatches){
                            this.selectedBatches = [];
                        }
                        let v = this.selectedBatches.reduce((a,c) => {return a + c.qty},0);
                        this.fulfilled_qty = v > this.required_qty ? this.required_qty : v;
                    }
                    let res = await axios.get(this.baseUrl + InboundOrderPath.GET_BATCH_LEVEL_STOCK,{
                        params : {
                            res_id : this.form.res_id,
                            type : this.type,
                            id : this.r.id
                        }
                    });
                    if(res.data.status){
                        this.data = res.data.data;
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        },
        mounted(){
            this.getBatches();
        }
    }
</script>

<template>
    <div>
        <b-row>
            <b-col>
                <label>Required Qty</label>
                <p>{{ required_qty }} {{ type == 'gravies' ? (r.units == 'pcs' ? 'Packets' : 'Kgs') : '' }}</p>
            </b-col>
            <b-col>
                <label>Fulfilled Qty</label>
                <p>{{ fulfilled_qty }} {{ type == 'gravies' ? (r.units == 'pcs' ? 'Packets' : 'Kgs') : '' }}</p>
            </b-col>
        </b-row>
        <div class="table-responsive">
            <b-table
                :key="data.key"
                :items="data.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
                >
                <template v-slot:cell(batch_code)="row">
                    {{ row.item.b_code }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button @click="addBatch(row.item)" v-if="selectedBatches.filter(f => f.b_code == row.item.b_code).length == 0" variant="success" size="sm">+</b-button>
                    <b-button @click="removeBatch(row.item)" v-else variant="danger" size="sm">-</b-button>
                </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination :key="data.key" v-model="currentPage" :total-rows="data.total" :per-page="data.per_page"></b-pagination>
                </ul>
            </div>
            </div>
        </div>
        <b-button variant="success" @click="save">Save</b-button>
    </div>
</template>

<style>
    
</style>